var _circle, _g, _path, _circle2, _g2, _path2, _circle3, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDollarsCoinsIcon = function SvgDollarsCoinsIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 4,
    width: 18,
    height: 18
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0001,
    cy: 13,
    r: 8,
    transform: "rotate(-10 24.0001 13)",
    fill: "#FEC807"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.0001,
    cy: 13,
    r: 8,
    transform: "rotate(-10 24.0001 13)",
    fill: "#FEC807"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.7424 14.2834 8.5713-12.24097 3.9319 2.75316-8.5712 12.24101-3.932-2.7532Z",
    fill: "#FFDA56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6623 21.712 31.0452 6.8838l3.2766 2.2943-10.3829 14.8282-3.2766-2.2943Z",
    fill: "#FFDA56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6252 16.5453c1.958-.3453 3.2654-2.2124 2.9202-4.1705-.3453-1.958-2.2125-3.26538-4.1705-2.92013-1.958.34526-3.2654 2.21243-2.9202 4.17043.3453 1.958 2.2125 3.2654 4.1705 2.9202Zm.3473 1.9696c3.0458-.5371 5.0795-3.4415 4.5425-6.4873-.5371-3.04586-3.4416-5.0796-6.4874-4.54254-3.0458.53706-5.0795 3.44154-4.5425 6.48734.5371 3.0458 3.4416 5.0796 6.4874 4.5425Z",
    fill: "#EEB13D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9725 18.5149c3.0458-.5371 5.0795-3.4415 4.5425-6.4873-.5371-3.04586-3.4416-5.0796-6.4874-4.54254-3.0458.53706-5.0795 3.44154-4.5425 6.48734.5371 3.0458 3.4416 5.0796 6.4874 4.5425Z",
    fill: "#EEB13D"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24.3169 18.6305-.2265-1.2845c-.8355.1056-1.682.0037-2.2044-.2101l.0922-1.6469c.5744.2191 1.3541.3745 2.1573.2329.7049-.1243 1.1343-.5074 1.039-1.0477-.0905-.5136-.5429-.7684-1.5179-.9444-1.4087-.2536-2.4304-.7701-2.6617-2.082-.2097-1.1892.3927-2.2574 1.6653-2.77391l-.2265-1.28413 1.212-.21369.2097 1.18956c.8355-.10527 1.4251-.0146 1.8714.13036l-.089 1.58981c-.3477-.0916-.9714-.30207-1.8614-.1451-.8039.1417-.9966.5661-.93.9439.0787.4465.5616.6539 1.6887.9013 1.5712.3083 2.2961.9467 2.5107 2.1637.2121 1.2026-.3858 2.3678-1.7601 2.8885l.2431 1.3787-1.2119.2137Z",
    fill: "#FEC807"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24.0906 17.346.2265 1.2845 1.2119-.2137-.2431-1.3787c1.3743-.5207 1.9722-1.6859 1.7601-2.8885-.0696-.3947-.1929-.7286-.3813-1.01l-2.9699 4.2413c.1314-.0067.2637-.0182.3958-.0349Z",
    fill: "#FFD646"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1276 5.001c1.1287 1.95151 1.7999 4.20075 1.8669 6.6011 2.1538 1.2443 3.885 3.1386 4.9254 5.4148C29.5343 19.3988 26.9541 21 24 21c-4.4183 0-8-3.5817-8-8 0-4.41828 3.5817-8 8-8 .0426 0 .0852.00033.1276.001Z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 11,
    width: 22,
    height: 22
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9998,
    cy: 22,
    r: 10,
    transform: "rotate(15 19.9998 22)",
    fill: "#FEC807"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.9998,
    cy: 22,
    r: 10,
    transform: "rotate(15 19.9998 22)",
    fill: "#FEC807"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56782 17.5068 22.7446 8.16716l3 5.19614L9.56782 22.703l-3-5.1962Z",
    fill: "#FFDA56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.616 30.1065 19.5959-11.3137 2.5 4.3301L14.116 34.4366l-2.5-4.3301Z",
    fill: "#FFDA56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8349 26.3467c2.4006.6432 4.8681-.7814 5.5113-3.182.6433-2.4006-.7814-4.8681-3.182-5.5114-2.4006-.6432-4.8681.7814-5.5113 3.182-.6433 2.4006.7814 4.8681 3.182 5.5114Zm-.6471 2.4148c3.7343 1.0006 7.5726-1.2155 8.5732-4.9498 1.0006-3.7342-1.2155-7.5726-4.9497-8.5732-3.7343-1.0006-7.5726 1.2155-8.5732 4.9498-1.0006 3.7342 1.2155 7.5726 4.9497 8.5732Z",
    fill: "#EEB13D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1878 28.7615c3.7343 1.0006 7.5726-1.2155 8.5732-4.9498 1.0006-3.7342-1.2155-7.5726-4.9497-8.5732-3.7343-1.0006-7.5726 1.2155-8.5732 4.9498-1.0006 3.7342 1.2155 7.5726 4.9497 8.5732Z",
    fill: "#EEB13D"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.3843 28.5461.422-1.5748c-1.0023-.3217-1.9074-.8843-2.3864-1.4025l.9745-1.8171c.535.5517 1.3363 1.1396 2.321 1.4035.8642.2316 1.5531.0244 1.7306-.638.1687-.6297-.2092-1.1573-1.2208-1.8718-1.4619-1.0315-2.3465-2.1563-1.9156-3.7648.3907-1.458 1.6375-2.3499 3.352-2.2628l.4218-1.5743 1.4859.3981-.3908 1.4584c1.0022.3222 1.6222.7363 2.0512 1.1363l-.9407 1.7541c-.3455-.2875-.9408-.8554-2.032-1.1478-.9856-.2641-1.4281.1149-1.5523.5782-.1466.5473.2908 1.0373 1.437 1.9131 1.6171 1.1793 2.1011 2.2855 1.7013 3.7775-.395 1.4744-1.6879 2.4787-3.5199 2.3426l-.4529 1.6903-1.4859-.3982Z",
    fill: "#FEC807"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.8062 26.9714-.422 1.5748 1.4859.3981.4529-1.6903c1.832.1361 3.1249-.8681 3.5199-2.3425.1297-.484.1664-.9273.1016-1.3457l-5.6051 3.2361c.1523.0617.3083.1186.4668.1695Z",
    fill: "#FFD646"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8105 25.9502C10.2889 24.7384 10 23.403 10 22c0-5.5228 4.4772-10 10-10 2.1939 0 4.2228.7065 5.8716 1.9044C24.9425 20.7355 19.086 26 12 26c-.4007 0-.7974-.0168-1.1895-.0498Z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FEC807"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FEC807"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m-4.96458 10.9636 15.84998-15.85L15.9766.204773.126592 16.0547l-5.091172-5.0911Z",
    fill: "#FFDA56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80004 24.0001 24 4.80015l4.2427 4.24264L9.04268 28.2428l-4.24264-4.2427Z",
    fill: "#FFDA56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 17.4c2.9823 0 5.4-2.4177 5.4-5.4 0-2.98233-2.4177-5.39999-5.4-5.39999-2.98234 0-5.4 2.41766-5.4 5.39999 0 2.9823 2.41766 5.4 5.4 5.4Zm0 3c4.6392 0 8.4-3.7608 8.4-8.4 0-4.63919-3.7608-8.39999-8.4-8.39999-4.63919 0-8.4 3.7608-8.4 8.39999 0 4.6392 3.76081 8.4 8.4 8.4Z",
    fill: "#EEB13D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 20.4c4.6392 0 8.4-3.7608 8.4-8.4 0-4.63919-3.7608-8.39999-8.4-8.39999-4.63919 0-8.4 3.7608-8.4 8.39999 0 4.6392 3.76081 8.4 8.4 8.4Z",
    fill: "#EEB13D"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0019 20.4v-1.9564c-1.26164-.0616-2.48556-.4327-3.20161-.8845l.5652-2.4089c.79147.4733 1.90271.9059 3.12621.9059 1.0735 0 1.8077-.4541 1.8077-1.277 0-.7822-.6019-1.2764-1.9963-1.7904-2.01489-.7416-3.38967-1.7707-3.38967-3.7689 0-1.81133 1.16811-3.23236 3.18247-3.66389v-1.9559h1.846v1.81187c1.2616.06212 2.1089.34963 2.7304.68001l-.5456 2.32531c-.4897-.22593-1.3561-.69924-2.7118-.69924-1.2244 0-1.6197.57666-1.6197 1.15221 0 .68001.6593 1.11209 2.2598 1.77123 2.2407.8647 3.1453 1.9966 3.1453 3.8502 0 1.8317-1.1867 3.3973-3.3525 3.8085V20.4h-1.8459Z",
    fill: "#FEC807"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0019 18.4436V20.4h1.8459v-2.0999c2.1658-.4112 3.3525-1.9768 3.3525-3.8085 0-.6012-.0952-1.1265-.3002-1.5914l-5.4919 5.4919c.1957.0243.3942.0418.5937.0515Z",
    fill: "#FFD646"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 18.3989,
    y: 7.39905,
    width: 11.2021,
    height: 11.2019,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.8,
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.883333 0 0 0 0 0.578751 0 0 0 0 0.298125 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_212_18020"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 12.998,
    y: 14.9983,
    width: 14.0034,
    height: 14.0035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.8,
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.883333 0 0 0 0 0.578751 0 0 0 0 0.298125 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_212_18020"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 3.6001,
    y: 3.60001,
    width: 16.7998,
    height: 16.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.8,
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.883333 0 0 0 0 0.578751 0 0 0 0 0.298125 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_212_18020"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDollarsCoinsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dollars-coins-icon.ceeafc9c21b6a429e4efd03a5adf2d02.svg";